import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './UserInfo.scss';
import lodash from 'lodash';
import { Link } from 'react-router';
import DateTime from 'common/components/DateTime/DateTime';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

const spaceRegexp = /\s+/;
const NonbreakingSpace = '\xa0';

const stateRanks = [
    'registration_initiated',
    'setting_password',
    'watch_training_video',
    'read_eula',
    'registration_complete',
];

const SortedListItems = (items) => {
    const sortedItems = lodash.sortBy(items, (i) => i.displayName);
    return sortedItems.map((item, index) => {
        let comma = (index + 1) == items.length ? '' : ', ';
        let displayName = (item.displayName || item.title).replace(spaceRegexp, NonbreakingSpace);
        return (
            <li className={styles.item} key={index} data-cy={'UserInfo' + index}>
                {displayName + comma}
            </li>
        );
    });
};

export default class UserInfo extends Component {

    calculateRegistrationDisplayName() {
        const registrationSteps = lodash.head(this.props.user.registrationSteps);
        const steps = lodash.get(registrationSteps, 'steps');

        if(!steps) {
            return 'A problem occurred when creating this user. Please try resetting their account.';
        }

        const currentStep = lodash.find(steps, function(step) {
            return step.stepStatus === 'current';
        });

        if (currentStep) {
            return currentStep.state.displayName;
        }

        steps.sort(function (lowerStep, higherStep) {
            const lowerStepRank = stateRanks.indexOf(lowerStep.state.name);
            const higherStepRank = stateRanks.indexOf(higherStep.state.name);
            if (lowerStepRank < higherStepRank){
                return -1;
            }
            if(lowerStepRank > higherStepRank){
                return 1;
            }
            return 0;
        });
        return lodash.last(steps).state.displayName;
    }

    calculateLastLogin() {
        const { lastLogin } = this.props.user;
        return !lastLogin ? '' : <DateTime value={lastLogin} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} time={true} />;
    }

    render() {
        const {
            emailAddress,
            createdAt,
            groups,
        } = this.props.user;
        let registration = this.calculateRegistrationDisplayName();
        const lastLogin = this.calculateLastLogin();
        return (
            <div data-cy="UserInfo-return">
                <div className={styles.details}>
                    <span className={styles.detail} data-cy="UserInfo-emailAddress">
                        {emailAddress}
                    </span>
                    <span className={styles.detailSeparator}>|</span>
                    <span className={styles.detail}>
                        Last&nbsp;Login:&nbsp;{lastLogin}
                    </span>
                    <span className={styles.detailSeparator}>|</span>
                    <span className={styles.detail}>
                        Created:&nbsp;<DateTime value={createdAt} applyTimezoneOffset={true}/>
                    </span>
                    <span className={styles.detailSeparator}>|</span>
                    <Link className={styles.detailLink} to={this.props.groupsPath}>
                        Groups:&nbsp;(&nbsp;{groups ? groups.length : 0}&nbsp;)
                    </Link>
                    <span className={styles.detailSeparator}>|</span>
                    <span className={styles.detail}>
                        Registration:&nbsp;{ registration }
                    </span>
                </div>
                <div className={styles.details}>
                    <span className={styles.groupIdentifier}>Groups:</span>
                    <ul className={styles.list} data-cy="UserInfo-ul">
                        { SortedListItems(groups || []) }
                    </ul>
                </div>
            </div>
        );
    }

}

UserInfo.propTypes = {
    user: PropTypes.object.isRequired
};
